import React from "react";
import Tooltip from "@mui/material/Tooltip";

const TableNumberInput = ({ formData, isMobile }) => {
  const tableNumbersRaw =
    formData?.tableNumberDetails ??
    formData?.number ??
    "";

  // Convert string to array
  const tableNumbers = tableNumbersRaw
    .split(",")
    .map((t) => t.trim())
    .filter(Boolean); // removes empty strings

  if (formData?.pdrNumberDetails) {
    tableNumbers.push(formData.pdrNumberDetails);
  }

  const displayTables = tableNumbers.slice(0, 2);
  const remainingCount = tableNumbers.length - displayTables.length;
  const displayValue = `Table No. ${displayTables.join(", ")}${remainingCount > 0 ? ` +${remainingCount}` : ""}`;
  const tooltipTitle = `Table No. ${tableNumbers.join(", ")}`;

  return (
    <Tooltip title={tableNumbers.length > 2 ? tooltipTitle : ""} placement="bottom" arrow>
      <input
        style={{
          fontSize: "16px",
          padding: "12px 12px",
          marginTop: isMobile ? "10px" : "0px",
          marginBottom: isMobile ? "10px" : "0px",
          backgroundColor: "#001a27",
          borderRadius: "169px",
          color: "#fff",
          fontWeight: "500",
          maxWidth: "150px",
          width: "fit-content",
          minWidth: "0",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          cursor: "default",
          textAlign: "center",
        }}
        value={displayValue}
        disabled
      />
    </Tooltip>
  );
};

export default TableNumberInput;
